// extracted by mini-css-extract-plugin
export default {"buttonGroup":"buttonGroup_buttonGroup__Z7Hzx","solo":"buttonGroup_solo__V21Ne"};